import { ComponentModelConfig, HeadBtnConfig } from 'liyu-pc-base/api/typing';

import { useUserStore } from 'liyu-pc-base/init-plugin';

import Handlebars from 'handlebars';
import modalBox from 'liyu-pc-base/components/form-modal/modal-tools';
import { useRequest } from 'liyu-pc-base/init-plugin';
import { getObjListBySelectedRowKeys } from 'liyu-pc-base/utils/function';
import { reactive, unref } from 'vue';

export const head_btn_custom_component = ({
  dataSource,
  button,
  selectedRowKeys,
  event_obj,
}: {
  dataSource: any[];
  button: HeadBtnConfig;
  selectedRowKeys: any[];
  event_obj: any;
}) => {
  const request = useRequest();
  const preProcessData = button.preProcessData;
  const model_config = button.model_config as ComponentModelConfig;
  const title = model_config.title;
  const component = model_config.component;
  const ok_url = model_config.ok_url;
  const cancel_url = model_config.cancel_url;
  const method = model_config.method || 'post';
  const init_data = model_config.init_data;
  const batch_api_fields = model_config.batch_api_fields;
  const userStore = useUserStore();
  const current_org = userStore.currentOrg; // 当前组织org
  const org_id = current_org?.id;
  let api_data = dataSource;
  if (preProcessData) {
    api_data = preProcessData({ dataSource, selectedRowKeys });
  }
  if (init_data) {
    api_data = { ...api_data, ...init_data };
  }
  const tempModal = reactive({
    open: true,
    loading: false,
    component: component,
    record: unref(api_data),
    dataSource: dataSource,
    button: button,
    title: Handlebars.compile(title || '')({ record: api_data }),
    ok: (data: any) => {
      data = { ...data, org_id };
      if (batch_api_fields) {
        data = {
          ...data,
          ...getObjListBySelectedRowKeys(batch_api_fields, dataSource, selectedRowKeys),
        };
      }
      if (ok_url) {
        request[method](ok_url, data).then(() => {
          event_obj.emit('refresh');
        });
      }
    },
    cancel: (data: any) => {
      data = { ...data, org_id };
      if (batch_api_fields) {
        data = {
          ...data,
          ...getObjListBySelectedRowKeys(batch_api_fields, dataSource, selectedRowKeys),
        };
      }
      if (cancel_url) {
        request[method](cancel_url, data).then(() => {
          event_obj.emit('refresh');
        });
      }
    },
  });
  modalBox(tempModal);
};
